import { __assign, __rest } from "tslib";
import React from 'react';
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
import { iconData } from './bullet-list.data';
import * as Styled from './bullet-list.styled';
import { BulletListType } from './bullet-list.types';
function getBulletElementFromListType(listType) {
    switch (listType) {
        case BulletListType.ORDERED:
            return Styled.BulletListOrdered;
        default:
            return Styled.BulletList;
    }
}
export var BulletList = function (_a) {
    var className = _a.className, items = _a.items, listType = _a.listType, _b = _a.iconColor, iconColor = _b === void 0 ? '' : _b, attributes = _a.attributes, otherHTMLProperties = __rest(_a, ["className", "items", "listType", "iconColor", "attributes"]);
    var BulletElement = getBulletElementFromListType(listType);
    var svgData = iconData[listType];
    var classList = conditionalClassList(listType, !!className && className);
    if (!items.length) {
        return null;
    }
    return (React.createElement(BulletElement, __assign({ className: classList }, attributes, otherHTMLProperties), items.map(function (item, key) { return (React.createElement(Styled.BulletListItem, { key: key },
        !!(svgData === null || svgData === void 0 ? void 0 : svgData.paths) && (React.createElement(Styled.BulletListSVG, { "$fillColor": iconColor || undefined, className: "".concat(listType, " ").concat(iconColor), svgContent: svgData.paths, title: "".concat(listType, " icon"), viewBox: "0 0 16 16", width: 16, height: 16 })),
        item)); })));
};
